<template>
	<el-drawer v-model="pop" title="" modal-class="mode-class" :with-header="false" direction="rtl" size="25%">
		<div class="full-100 flex-column">
			<PageTitle name="待办事项"></PageTitle>
			<ul v-infinite-scroll="GetList" style="overflow-y: scroll;" :infinite-scroll-immediate="false">
				<li v-for="(v, i) in list" :key="i">
					<div class="ptb-12 boderb1-EBEBED pointer" @click="ClickOrderStatusItem(v)">
						<div class="flex-row-center-sb">
							<div class="fz-14 co-1F2533 one-row flex-1">{{v.content}}</div>
							<div class="flex-row-center-start">
								<div class="point mr-4" v-if="v.is_read == 0"></div>
								<div class="fz-12 co-949CA9">立即处理</div>
								<img class="wh-10 ml-5" src="@/assets/icon_48.png" alt=''>
							</div>
						</div>
						<div class="fz-12 co-949CA9 mt-6">{{v.create_time}}</div>
					</div>
				</li>
			</ul>
		</div>
	</el-drawer>
</template>

<script lang="ts" setup>
	import { ref, defineExpose, getCurrentInstance } from 'vue';
	import config from '@/api/config';

	const { proxy } = getCurrentInstance() as any;
	const pop = ref(false);
	const total = ref<any>(0);
	const list = ref<any>([]);
	const page = ref(1);
	const size = ref(config.PagesSize[0]);
	const loading = ref<any>(false);
	const boxRef = ref<any>();
	const boxHeight = ref<any>(0);

	const open = () => {
		pop.value = true;
		RefreshList({
			page: 0,
		});
	};
	const close = () => {
		pop.value = false;
	};
	const ClickOrderStatusItem = (data : any) => {
		proxy.$api.tokenRequest({
			url: '/admin/notice/reads',
			isLoading: '加载中...',
			method: "POST",
			data: {
				id: data.id,
			},
			success: () => {
				RefreshList({
					page: 1,
				});
			}
		});
		if (data.target_url == "type=1") {
			return false;
		}
		if (data.type == 2) {
			proxy.$router.replace({
				path: "/GoodManage/InventoryAlert",
			});
		} else {
			proxy.$router.replace({
				path: "/ReportManager/NotificationRecord",
			});
		}
		close();
	};
	const GetList = () => {
		if (loading.value) return false
		loading.value = true;
		let pages = page.value;
		pages++;
		proxy.$api.tokenRequest({
			url: '/admin/notice/system',
			isLoading: '加载中...',
			data: {
				page: pages,
				size: size.value,
			},
			success: (res : any) => {
				loading.value = false;
				list.value = list.value.concat(res.data.data);
				total.value = res.data.total;
				if (res.data.data.length > 0) {
					page.value = pages;
				}
			},
			fail: () => {
				loading.value = false;
			}
		});
	};
	const RefreshList = (data : any) => {
		list.value = [];
		page.value = data.page;
		GetList();
	};

	defineExpose({
		open,
		close,
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/publicscss/publicscss.scss";

	.point {
		width: 8px;
		height: 8px;
		background: #F52F3E;
		border-radius: 8px;
	}
</style>